const MESSAGE_CLASSES = {
    success: 'm-success',
    info: '',
    error: 'm-error'
};

/**
 * @param AjaxForm Base widget for extending
 * @returns SMS Subscription Mixin class
 */
function AjaxResponseMessageMixinClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    class AjaxResponseMessageMixin extends AjaxForm {
        responseMessageRef;

        errorMessageRef;

        /**
         * @description Widget initialization
         */
        init() {
            super.init();

            this.responseMessageRef = this.ref('responseMessage');
            this.errorMessageRef = this.ref('errorMessage');
        }

        onSubmitted(data) {
            const { success, responseMessage, messageType } = data;

            if (responseMessage && success) {
                this.eachField(field => field.clearError());

                this.hideErrorMessage();
                this.showResponseMessage(responseMessage, messageType);
            } else if (responseMessage) {
                this.hideResponseMessage();
                this.showErrorMessage(responseMessage);
            } else {
                super.onSubmitted(data);
            }
        }

        /**
         * @description Show response message with specific type
         * @param responseMessage Message to show
         * @param messageType Type of message (success, info, error)
         */
        showResponseMessage(responseMessage = '', messageType = ''): void {
            const messageTypeClass = MESSAGE_CLASSES[messageType];

            this.responseMessageRef.removeClass([MESSAGE_CLASSES.success, MESSAGE_CLASSES.info]);

            if (messageTypeClass) {
                this.responseMessageRef.addClass(messageTypeClass);
            }

            this.responseMessageRef.setHtml(responseMessage).show();
        }

        /**
         * @description Hide response message
         */
        hideResponseMessage(): void {
            this.responseMessageRef.empty().hide();
        }

        /**
         * @description Show error message
         * @param errorMessage Message to show
         */
        showErrorMessage(errorMessage = ''): void {
            this.errorMessageRef.setHtml(errorMessage).show();
        }

        /**
         * @description Hide error message
         */
        hideErrorMessage(): void {
            this.errorMessageRef.empty().hide();
        }
    }

    return AjaxResponseMessageMixin;
}

export type TResponseMessageMixin = ReturnType<typeof AjaxResponseMessageMixinClassCreator>;

export type TResponseMessageMixinInstance = InstanceType<TResponseMessageMixin>;

export default AjaxResponseMessageMixinClassCreator;
